"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/patientResponse/AppPrompts.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _urls = require('web/services/urls');

/* Store links on the secure-link patient page (P5). A plain link requires
 * a tap; scanners and desktops never launch the app or send a message.
 * One prompt per platform, decided from the user agent and input type,
 * never from screen width: iOS Safari gets only Apple's Smart App Banner;
 * other iOS browsers and Android get the full-width GetTheAppBar; a touch
 * device whose OS is not recognised gets a manual link to the download
 * chooser, so no store is guessed; desktops get nothing. */

/* Set to false to turn off the Smart App Banner, app bar and manual link
 * everywhere, so every platform gets the logo and "Need help?" row. While it
 * is true, the page still shows them only on chats whose clinic has
 * "Patients can use the app" on (patientResponse/index.tsx). */
 const PATIENT_APP_PROMPTS_ENABLED = true; exports.PATIENT_APP_PROMPTS_ENABLED = PATIENT_APP_PROMPTS_ENABLED

 const IOS_APP_ID = '1294498284'; exports.IOS_APP_ID = IOS_APP_ID
 const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.bloomapi.bloomtext'; exports.PLAY_STORE_URL = PLAY_STORE_URL
 const GET_THE_APP_COPY = 'Open in the app'; exports.GET_THE_APP_COPY = GET_THE_APP_COPY
 const APP_STORE_URL = `https://apps.apple.com/app/id${exports.IOS_APP_ID}`; exports.APP_STORE_URL = APP_STORE_URL

// The bar's dismissal, unchanged since it first shipped.
const DISMISSED_KEY = 'bloomtext.getTheAppBarDismissed'








const isIOSBrowser = (userAgent, { maxTouchPoints }) =>
  /iPhone|iPad|iPod/i.test(userAgent)
  || (/Macintosh/i.test(userAgent) && maxTouchPoints > 1)

// Safari proper, the only iOS browser that shows the Smart App Banner. Other
// iOS browsers (Chrome, Firefox, Edge, Opera, the Google app) add their own
// token; in-app browsers usually drop "Safari" altogether.
const isSafariUserAgent = (userAgent) => /Safari/i.test(userAgent)
  && !/CriOS|FxiOS|EdgiOS|OPiOS|OPT\/|GSA\/|DuckDuckGo|YaBrowser/i.test(userAgent)

 const classifyAppPlatform = (userAgent, input) => {
  if (/Android/i.test(userAgent)) return 'android'
  if (isIOSBrowser(userAgent, input)) {
    return isSafariUserAgent(userAgent) ? 'ios-safari' : 'ios-other'
  }
  // Android's desktop-site mode and other masked mobiles land here; touch
  // laptops do too, and only ever see the optional manual link.
  if (input.maxTouchPoints > 0 || input.coarsePointer) return 'unknown-touch'
  return 'desktop'
}; exports.classifyAppPlatform = classifyAppPlatform

const readAppPlatform = () => exports.classifyAppPlatform.call(void 0, window.navigator.userAgent || '', {
  maxTouchPoints: window.navigator.maxTouchPoints || 0,
  // jsdom and some old embedded browsers have no matchMedia.
  coarsePointer: _nullishCoalesce(_optionalChain([window, 'access', _ => _.matchMedia, 'optionalCall', _2 => _2('(pointer: coarse)'), 'access', _3 => _3.matches]), () => ( false)),
})

const readDismissed = () => {
  try {
    return window.localStorage.getItem(DISMISSED_KEY) === '1'
  } catch (e) {
    return false
  }
}

const writeDismissed = () => {
  try {
    window.localStorage.setItem(DISMISSED_KEY, '1')
  } catch (e2) {
    // Private mode or blocked storage: it stays dismissed for this page view.
  }
}

const storeUrlFor = (platform) => {
  if (platform === 'android') return exports.PLAY_STORE_URL
  if (platform === 'ios-other') return exports.APP_STORE_URL
  return null
}











// `offered` is false on pages that never show the app bar or manual link
// (invalid, failed and disconnected); Apple's banner shows on every page.
// The page passes `enabled` off for an org with the patient app off, or not
// yet known (see patientResponse/index.tsx).
// `enabled` exists so specs can exercise the prompts while they are off.
 const useAppPrompt = (offered, enabled = exports.PATIENT_APP_PROMPTS_ENABLED) => {
  const [platform] = _react.useState.call(void 0, readAppPlatform)
  const [isDismissed, setIsDismissed] = _react.useState.call(void 0, readDismissed)

  const dismiss = _react.useCallback.call(void 0, () => {
    writeDismissed()
    setIsDismissed(true)
  }, [])

  const storeUrl = enabled && offered && !isDismissed ? storeUrlFor(platform) : null

  return {
    storeUrl,
    dismiss,
    showsManualLink: enabled && offered && platform === 'unknown-touch',
    bannerAbove: storeUrl !== null,
  }
}; exports.useAppPrompt = useAppPrompt

 const useSmartAppBanner = (enabled = exports.PATIENT_APP_PROMPTS_ENABLED) => {
  _react.useLayoutEffect.call(void 0, () => {
    if (!enabled) return undefined
    if (document.head.querySelector('meta[name="apple-itunes-app"]')) return undefined
    const meta = document.createElement('meta')
    meta.setAttribute('name', 'apple-itunes-app')
    meta.setAttribute('content', `app-id=${exports.IOS_APP_ID}`)
    document.head.appendChild(meta)
    return () => { meta.remove() }
  }, [enabled])
}; exports.useSmartAppBanner = useSmartAppBanner

 const GetTheAppBar = ({ prompt }) => {
  if (!prompt.storeUrl) return null

  return (
    _react2.default.createElement('div', { className: "get-the-app-bar", role: "region", 'aria-label': "BloomText app" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 133}}
      , _react2.default.createElement('img', { className: "get-the-app-bar--icon", src: "/assets/icons/logo-256x256.png", alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 134}} )
      , _react2.default.createElement('span', { className: "get-the-app-bar--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 135}}, "BloomText")
      , _react2.default.createElement('a', {
        className: "get-the-app-bar--link",
        href: prompt.storeUrl,
        target: "_blank",
        rel: "noopener noreferrer" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 136}}

        ,  exports.GET_THE_APP_COPY 
      )
      , _react2.default.createElement('button', {
        type: "button",
        className: "get-the-app-bar--close",
        'aria-label': "Dismiss app prompt"  ,
        onClick: prompt.dismiss, __self: this, __source: {fileName: _jsxFileName, lineNumber: 144}}
, "×"

      )
    )
  )
}; exports.GetTheAppBar = GetTheAppBar

// For touch devices whose OS is not recognised: the chooser lets the
// patient pick a store instead of us guessing one.
 const ManualAppLink = () => (
  _react2.default.createElement('div', { className: "patient-conversation--manual-app-link", __self: this, __source: {fileName: _jsxFileName, lineNumber: 159}}
    , _react2.default.createElement('a', { href: _urls.appSmartLinkUrl, target: "_blank", rel: "noopener noreferrer" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 160}}, "Get the app"

    )
  )
); exports.ManualAppLink = ManualAppLink
